import apiClient from './client';
import type { JobTitle, CohortJobTitleAssignment, JobTitleAssignmentInput } from '../../types';

/**
 * API for managing job titles and cohort job title assignments
 */
export const jobTitlesApi = {
  /**
   * Get all active job titles
   */
  getAll: async (): Promise<JobTitle[]> => {
    return apiClient.get<JobTitle[]>('/api/job-titles');
  },

  /**
   * Get a single job title by ID
   */
  getById: async (id: string): Promise<JobTitle> => {
    return apiClient.get<JobTitle>(`/api/job-titles/${id}`);
  },

  /**
   * Get job title assignments for a cohort
   */
  getCohortAssignments: async (cohortId: string): Promise<CohortJobTitleAssignment[]> => {
    return apiClient.get<CohortJobTitleAssignment[]>(`/api/cohorts/${cohortId}/job-assignments`);
  },

  /**
   * Update job title assignments for a cohort
   * Replaces all existing assignments
   */
  updateCohortAssignments: async (
    cohortId: string,
    assignments: JobTitleAssignmentInput[],
  ): Promise<CohortJobTitleAssignment[]> => {
    return apiClient.put<CohortJobTitleAssignment[]>(
      `/api/cohorts/${cohortId}/job-assignments`,
      { assignments },
    );
  },

  /**
   * Initialize job title assignments for a cohort
   * Creates unassigned entries for all active job titles
   */
  initializeAssignments: async (cohortId: string): Promise<CohortJobTitleAssignment[]> => {
    return apiClient.post<CohortJobTitleAssignment[]>(
      `/api/cohorts/${cohortId}/job-assignments/initialize`,
    );
  },
};

export default jobTitlesApi;
